export enum TO_LINK {
  MAIN = '/',
  TECH = '/tech',
  OFFICE = '/office',
  OPERATIONS = '/operations',
  CATALOG_VACANCIES = '/catalog-vacancies',
  JOB_SITE = 'https://job.sbermarket.ru',
}

export const HEADER_LINKS = [
  {
    id: 1,
    title: 'О компании',
    to: TO_LINK.MAIN,
    isNavLink: true,
  },
  {
    id: 2,
    title: 'Разрабатываем',
    to: TO_LINK.TECH,
    isNavLink: true,
  },
  {
    id: 3,
    title: 'Развиваем',
    to: TO_LINK.OFFICE,
    isNavLink: true,
  },
  {
    id: 4,
    title: 'Поддерживаем',
    to: TO_LINK.OPERATIONS,
    isNavLink: true,
  },
  {
    id: 6,
    title: 'Доставляем',
    to: TO_LINK.JOB_SITE,
    isNavLink: false,
  },
  {
    id: 5,
    title: 'Вакансии',
    to: TO_LINK.CATALOG_VACANCIES,
    isNavLink: true,
  },
];
